import { useState } from "react";
import { Globe, X } from "lucide-react";
import { useLang, browserLang, BANNER_INVITE, LANG_LABELS } from "../lib/i18n";

const DISMISS_KEY = "amd-lang-banner-dismissed";

export const LanguageBanner = () => {
  const { lang, setLang } = useLang();
  const target = browserLang();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "1"
  );

  // Only invite when the browser prefers a non-English language but the UI is English.
  if (dismissed || lang !== "en" || target === "en" || !BANNER_INVITE[target]) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      data-testid="language-banner"
      className="bg-teal-600 text-white"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-sm sm:text-base font-medium">
          <Globe className="w-4 h-4 shrink-0" />
          {BANNER_INVITE[target]}
        </span>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => {
              setLang(target);
              dismiss();
            }}
            data-testid="language-banner-switch"
            className="bg-white text-teal-700 font-bold text-sm px-4 py-1.5 rounded-lg hover:bg-teal-50 transition-colors"
          >
            {LANG_LABELS[target]}
          </button>
          <button
            onClick={dismiss}
            data-testid="language-banner-dismiss"
            aria-label="Dismiss"
            className="p-1.5 rounded-lg hover:bg-teal-500 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
